import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';

import Overview from './containers/analyse/Overview';
import Select from './containers/analyse/Select';
import InfoPage from './containers/analyse/InfoPage';
import Video from './containers/analyse/Video';

import { ROUTE_ANALYSE_OVERVIEW } from './RouteList';

function OverviewRoute() {
  const { videoAnalyseId } = useParams();
  return <Overview videoAnalyseId={videoAnalyseId} />;
}

function SelectRoute() {
  const { videoAnalyseId, analyseId } = useParams();
  return <Select videoAnalyseId={videoAnalyseId} analyseId={analyseId} />;
}

function InfoRoute() {
  const { videoAnalyseId, analyseId } = useParams();
  return <InfoPage videoAnalyseId={videoAnalyseId} analyseId={analyseId} />;
}

function VideoRoute() {
  const { videoAnalyseId, analyseId } = useParams();
  return <Video videoAnalyseId={videoAnalyseId} analyseId={analyseId} />;
}

function AnalyseApp() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Use relative paths; this component is mounted at /analyse/*
  return (
    <BasePage>
      <Content>
        <Routes>
          <Route path="overview/:videoAnalyseId?" element={<OverviewRoute />} />
          <Route
            path="select/:videoAnalyseId/:analyseId?"
            element={<SelectRoute />}
          />
          <Route
            path="info/:videoAnalyseId/:analyseId"
            element={<InfoRoute />}
          />
          <Route
            path="video/:videoAnalyseId/:analyseId"
            element={<VideoRoute />}
          />

          {/* default */}
          <Route
            path="*"
            element={<Navigate to={ROUTE_ANALYSE_OVERVIEW} replace />}
          />
        </Routes>
      </Content>
    </BasePage>
  );
}

export default observer(AnalyseApp);
